module.exports = __webpack_public_path__ + "img/tabiko-logo.989d02e2.png";